export default "__VITE_ASSET__Dt2wU$T7__"